module.exports = __webpack_public_path__ + "img/chevron-down-outline.fa56aece.png";